import { Idiomorph } from '@vendor/idiomorph';

/**
 * @param {Element} oldTree - The existing DOM tree
 * @param {Element | Node | HTMLCollection | Node[] | string | null} newTree - The new DOM tree to morph to
 * @returns {Node} The morphed DOM tree
 */
export function morph(oldTree, newTree) {
  if (oldTree instanceof Element && oldTree.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') {
    return oldTree;
  }

  Idiomorph.morph(oldTree, newTree);
  return oldTree;
}
